export default "__VITE_ASSET__Djz7t1p4__"